export default "__VITE_ASSET__CZaplFlT__"